/**
 * Indian mobile numbers on accounts. The server (`rai.platform.phone`) is the
 * rule; this mirrors it so the form can say what's wrong before sending.
 * Stored as +91XXXXXXXXXX, not verified yet (OTP once WhatsApp is set up).
 */

export const MOBILE_MESSAGE = "Enter a 10-digit Indian mobile number";

/**
 * What the input keeps while typing: digits only, at most 10. A typed or
 * pasted 91 / +91 / 0 in front is dropped once the number runs past 10 digits.
 */
export function mobileInput(raw: string): string {
  let d = raw.replace(/\D/g, "");
  if (d.length > 10 && d.startsWith("91")) d = d.slice(2);
  else if (d.length > 10 && d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 10);
}

/** The 10 national digits of a valid Indian mobile, or null. */
export function validMobile(raw: string): string | null {
  const d = mobileInput(raw);
  return /^[6-9]\d{9}$/.test(d) ? d : null;
}

/** '+919876543210' → '+91 98765 43210'; other stored formats unchanged. */
export function formatMobile(stored: string | null | undefined): string {
  if (!stored) return "";
  const m = /^\+91(\d{5})(\d{5})$/.exec(stored);
  return m ? `+91 ${m[1]} ${m[2]}` : stored;
}
